import { DOOR_GLASS_8, DOOR_GLASS_10, DOOR_GLASS_876 } from './doorGlassTypes';

const doorGlassTypes = [DOOR_GLASS_8, DOOR_GLASS_10, DOOR_GLASS_876];

export default doorGlassTypes;
